import React, { useState, useEffect, useCallback } from 'react';
import { flowRight as compose } from 'lodash';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';

import s from './Layout5.css';

// Components
import SearchForm from '../SearchForm/SearchForm';

const Layout5 = ({ title, content, homeBannerImages, isLoading }) => {
  const [hideMenu, setHideMenu] = useState('');

  const handleScroll = useCallback(() => {
    const top = document.documentElement.scrollTop || document.body.scrollTop;
    const isWeb = window.matchMedia('(min-width: 1300px)').matches;
    setHideMenu(isWeb && top >= 80 ? 'hideMenu' : '');
  }, []);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.addEventListener('scroll', handleScroll);
      window.addEventListener('resize', handleScroll);
      // Initial check
      handleScroll();
    }

    return () => {
      if (typeof window !== 'undefined') {
        window.removeEventListener('scroll', handleScroll);
        window.removeEventListener('resize', handleScroll);
      }
    };
  }, [handleScroll]);

  const path = '/images/home/';
  const homeBannerFirst = homeBannerImages?.[0]?.name ? path + homeBannerImages[0].name : '';
  const layout5Css = 'layout5Css';

  return (
    <div>
      <div className={cx(s.bannerLayoutContainer, 'layoutFive')}>
        <div
          className={cx(s.bannerBackgroundImage)}
          style={{ backgroundImage: `url(${homeBannerFirst})` }}
        />
        <div className={s.searchFormContainer}>
          <div className={cx(s.marginTop, hideMenu)}>
            <SearchForm
              layout5Css={layout5Css}
              id={'layoutFive'}
              isLoading={isLoading}
            />
          </div>
          <div className={s.positionRelative}>
            <h1 className={cx(s.noMargin, s.bannerCaptionText)}>
              <span>{title}</span>
            </h1>
            <h2 className={cx(s.noMargin, s.bannerCaptionTextH2)}>
             <span>{content}</span>
            </h2>
          </div>
        </div>
      </div>
    </div>
  );
};

export default compose(withStyles(s))(Layout5);